<template>
  <div class="interview-box">
    <div class="inner animated fadeInDown slow">
      <div class="title">赛码视频面试</div>
      <div class="intro">
        不仅仅只是考试，赛码视频面试一站到底<br />
        赛码支持：单面、群面、电脑面、手机面，音视频通话，演示文件、共享桌面、在线编程、在线评价、面试叫号系统<br />
        720P高清视频，系统支持5万人高并发同时在线面试，流畅无卡顿<br />
        面试双方用户无需下载软件即可面试
      </div>
      <div class="tiyanbtn btn">
        <a @click="viewDetail">查看详情</a>
      </div>
    </div>
    <div class="carousel-box animated fadeInUp slow">
      <carousel-3d :autoplay="true">
        <slide :index="0">
          <img src="@/static/images/home-four-2.png" />
        </slide>
        <slide :index="1">
          <img src="@/static/images/home-four-1.png" />
        </slide>
        <slide :index="2">
          <img src="@/static/images/home-four-3.png" />
        </slide>
      </carousel-3d>
    </div>
  </div>
</template>

<script>
import { Carousel3d, Slide } from 'vue-carousel-3d'
export default {
  components: {
    Carousel3d,
    Slide,
  },
  methods: {
    viewDetail() {
      this.$router.push('/product/interview')
    },
    mouseoverHandler(num) {
      this.isActive = num
    },
  },
}
</script>

<style lang="scss" scoped>
.inner {
  margin: auto;
  position: relative;
}
.interview-box {
  padding: 50px 0px 0px;
  text-align: center;
  .inner {
    padding: 0px 10px;
  }
}
.title {
  font-size: 36px;
  font-weight: 300;
}
.intro {
  font-size: 14px;
  padding: 20px 0px;
  color: #999;
  line-height: 25px;
  font-weight: 300;
}

.carousel-box {
  padding: 30px 100px 0px;
  margin: 0px auto;
  width: 1000px;
}

@media screen and (max-width: 600px) {
  .intro {
    font-size: 12px;
  }
  .carousel-box {
    padding: 10px 0px 0px;
    width: 100%;
  }
  .carousel-3d-slider {
    transform: scale(0.8);
  }
}
</style>
<style lang='scss'>
@media screen and (max-width: 600px) {
  .interview-box {
    .carousel-3d-slider {
      transform: scale(0.8);
    }
    .title {
      font-size: 28px;
    }
  }
}
</style>
<style lang='scss'>
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .interview-box {
    .intro {
      padding: 20px 150px;
    }
    .carousel-box {
      width: initial !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/interviewIntro.vue